document.addEventListener('DOMContentLoaded', () => {
    const isMobile = () => window.innerWidth <= 768;

    const heroLeftSide = document.querySelector('.hero-left-side');
    const heroRightSide = document.querySelector('.hero-right-side');
    const heroBottomImg = document.querySelector('.hero-bottom-img');

    const elements = {
        heroLeftSide: heroLeftSide !== null,
        heroRightSide: heroRightSide !== null,
        heroBottomImg: heroBottomImg !== null
    };

    if ((!elements.heroLeftSide && !elements.heroRightSide && !elements.heroBottomImg) || isMobile()) {
        console.log('Scroll animations disabled: ' +
            (isMobile() ? 'Mobile device detected' : 'No animation elements found'));
        return;
    }

    const animations = {
        heroLeftSide: {
            initialScale: 1,
            finalScale: 1,
            initialX: 0,
            finalX: -200,
            startOffset: 200,
            endOffset: 650
        },
        heroRightSide: {
            initialScale: 1,
            finalScale: 1,
            initialX: 0,
            finalX: 200,
            startOffset: 150,
            endOffset: 650
        },
        heroBottomImg: {
            initialScale: 1,
            finalScale: 0.9,
            initialY: 0,
            finalY: 40,
            startOffset: 100,
            endOffset: 650
        }
    };

    function calculateProgress(scrollPosition, startOffset, endOffset) {
        let progress = (scrollPosition - startOffset) / (endOffset - startOffset);
        progress = Math.max(0, Math.min(1, progress));
        return easeInOutCubic(progress);
    }

    function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function updateElement(element, config, scrollPosition) {
        if (!element) return;

        const progress = calculateProgress(scrollPosition, config.startOffset, config.endOffset);

        const currentScale = config.initialScale - (progress * (config.initialScale - config.finalScale));

        if ('finalX' in config) {
            const currentX = config.initialX + (progress * (config.finalX - config.initialX));
            element.style.transform = `translateX(${currentX}%) scale(${currentScale})`;
        } else if ('finalY' in config) {
            const currentY = config.initialY + (progress * (config.finalY - config.initialY));
            element.style.transform = `translateY(${currentY}%) scale(${currentScale})`;
        }
    }

    function updateAnimations() {
        const scrollPosition = window.scrollY;

        if (elements.heroLeftSide) {
            updateElement(heroLeftSide, animations.heroLeftSide, scrollPosition);
        }

        if (elements.heroRightSide) {
            updateElement(heroRightSide, animations.heroRightSide, scrollPosition);
        }

        if (elements.heroBottomImg) {
            updateElement(heroBottomImg, animations.heroBottomImg, scrollPosition);
        }
    }

    function adjustAnimationParameters() {
        const heightRatio = window.innerHeight / 1000;

        Object.keys(animations).forEach(key => {
            if (animations[key]) {
                animations[key].startOffset = Math.round(animations[key].startOffset * heightRatio);
                animations[key].endOffset = Math.round(animations[key].endOffset * heightRatio);
            }
        });

        updateAnimations();
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateAnimations();
                ticking = false;
            });
            ticking = true;
        }
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
        if (isMobile()) {
            if (heroLeftSide) heroLeftSide.style.transform = '';
            if (heroRightSide) heroRightSide.style.transform = '';
            if (heroBottomImg) heroBottomImg.style.transform = '';
            return;
        }

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            adjustAnimationParameters();
        }, 250);
    });

    adjustAnimationParameters();
    updateAnimations();
});
